import styled from 'styled-components'

import { ClinTheme } from '../../../../ClinTheme'
import { mediaQuery, mediaQueryDown } from '../../../../utils/mediaQuery'
import { ISearchStylesProps } from '../../AutoSuggest/AutoSuggest'

const mobileUpBreakpoint = ClinTheme.breakpoints[2]

export const StyledGlobalSearch = styled.section({
  [`@media print`]: {
    display: 'none'
  }
})

export const StyledGlobalSearchHome = styled.section({
  padding: `${ClinTheme.space[2]}px ${ClinTheme.space[3]}px`,
  backgroundColor: ClinTheme.colors.primaryLight,
  [mediaQuery(mobileUpBreakpoint)]: {
    padding: `${ClinTheme.space[4]}px ${ClinTheme.space[3]}px`
  },
  [`@media print`]: {
    display: 'none'
  }
})

export const StyledSearchWrapper = styled.div<ISearchStylesProps>(
  {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '-6px',
    height: '40px',
    padding: '0px 16px',
    marginRight: '18px',
    backgroundColor: ClinTheme.colors.white,

    [`.search-icon`]: {
      width: '18px',
      height: '18px',
      position: 'absolute',
      left: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1
    },
    [mediaQueryDown(mobileUpBreakpoint)]: {
      marginTop: '-2px',
      height: '40px',
      marginLeft: '16px',
      [`.clin-icon`]: {
        left: '16px'
      }
    },
    [mediaQuery(mobileUpBreakpoint)]: {
      marginLeft: '18px',
      marginRight: '18px',
      minWidth: '312px',
      width: '312px',
      maxWidth: '768px',
      height: '48px',
      marginTop: '-12px',
      padding: '0',
      transition: 'width .3s ease-in-out',
      [`&:focus-within`]: {
        width: 'calc(100% - 28px);',
        outline: 'none'
      }
    },
    [`&.clin-global-search-menu-input-wrapper`]: {
      height: '48px',
      marginTop: '0',
      marginRight: '32px',
      backgroundColor: 'transparent',
      borderRadius: '0',
      [`.clin-icon`]: {
        paddingBottom: '8px',
        position: 'static',
        transform: 'none',
        paddingLeft: '0px'
      }
    }
  },
  ({ isHeader, showSuggestions }) => ({
    borderRadius: isHeader && showSuggestions ? '0' : '24px',
    borderTopLeftRadius: '24px',
    borderTopRightRadius: '24px'
  })
)

export const StyledSearchWrapperHome = styled.div({
  backgroundColor: ClinTheme.colors.primaryLight,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  minWidth: '312px',
  width: '312px',
  maxWidth: '768px',
  height: '40px',
  transition: 'width .3s ease-in-out',
  marginRight: '18px',
  marginTop: '-7px',
  [`.clin-icon`]: {
    transition: '.2s linear color',
    color: ClinTheme.colors.white
  },
  [`> input:focus`]: {
    [`~ .clin-icon`]: {
      color: ClinTheme.colors.primary
    }
  },
  [mediaQuery(mobileUpBreakpoint)]: {
    maxWidth: 650,
    margin: 'auto'
  }
})

export const StyledSearchInput = styled.input<ISearchStylesProps>(
  {
    fontFamily: ClinTheme.fonts.body,
    textOverflow: 'ellipsis',
    position: 'relative',
    flex: '1 1 auto',
    marginBottom: '0',
    width: '100%',
    height: '100%',
    paddingLeft: '40px', // Reduced space for search icon to bring text closer
    paddingRight: ClinTheme.space[3],
    paddingTop: '0',
    paddingBottom: '0',
    fontSize: '14px',
    fontWeight: ClinTheme.fontWeights.normal,
    lineHeight: '24px',
    color: ClinTheme.colors.black,
    backgroundColor: 'transparent',
    borderStyle: 'none',
    outline: 'none',
    transition: '.2s linear color, .2s linear width',
    '::placeholder': {
      color: '#979797'
    },
    ':-ms-input-placeholder': {
      // Special case for Text Inputs to have correct height in IE 11
      height: '40px'
    },
    [`:focus`]: {
      width: '100%'
    },
    [mediaQueryDown(mobileUpBreakpoint)]: {
      padding: '0 0 0 28px'
    },
    [`&.clin-global-search-menu-input`]: {
      paddingLeft: ClinTheme.space[4],
      backgroundColor: 'transparent',
      borderRadius: '0',
      color: ClinTheme.colors.deepGrey,
      '::placeholder': {
        color: 'inherit'
      }
    }
  },
  ({ isHeader, showSuggestions }) => ({
    borderRadius: isHeader && showSuggestions ? '0' : '24px',
    borderTopLeftRadius: '24px',
    borderTopRightRadius: '24px'
  })
)

export const StyledSearchInputAus = styled.input<ISearchStylesProps>({
  fontFamily: ClinTheme.fonts.body,
  position: 'relative',
  flex: '1 1 auto',
  marginBottom: '0',
  textIndent: ClinTheme.space[4],
  padding: `${ClinTheme.space[2]}px ${ClinTheme.space[2]}px`,
  fontSize: ClinTheme.fontSizes[2],
  fontWeight: ClinTheme.fontWeights.light,
  color: ClinTheme.colors.white,
  borderRadius: ClinTheme.space[5],
  transition: '.2s linear background-color, .2s linear color',
  '::placeholder': {
    color: 'inherit'
  },
  ':-ms-input-placeholder': {
    // Special case for Text Inputs to have correct height in IE 11
    height: '40px'
  },
  [`:focus`]: {
    color: ClinTheme.colors.primary,
    backgroundColor: ClinTheme.colors.white,
    outline: '0'
  },
  [mediaQuery(mobileUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[3]
  }
})

export const StyledResults = styled.ul<ISearchStylesProps>(
  {
    listStyle: 'none',
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    marginTop: '8px',
    padding: '8px',
    zIndex: ClinTheme.zIndices.searchDropdown,
    backgroundColor: ClinTheme.colors.lightGrey,
    borderRadius: '8px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
    [mediaQuery(mobileUpBreakpoint)]: {
      padding: '8px'
    },
    [mediaQueryDown(mobileUpBreakpoint)]: {
      marginLeft: '16px',
      marginRight: '-16px'
    },
    [`&.clin-global-search-menu-results`]: {
      marginTop: '-8px',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      borderRadius: '0',
      padding: 0
    }
  },
  ({ showSuggestions }) => ({
    display: showSuggestions ? 'block' : 'none'
  }),
  ({ isHeader }) => ({
    ...(isHeader && {
      marginTop: '0',
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      [mediaQuery(mobileUpBreakpoint)]: {
        padding: '0'
      }
    })
  })
)

export const StyledResultsWithNewFeature = styled.ul<ISearchStylesProps>(
  {
    listStyle: 'none',
    position: 'absolute',
    top: '26px',
    left: '51px',
    right: 0,
    margin: 0,
    zIndex: 1300,
    pointerEvents: 'auto',
    boxShadow: `0px 4px 8px 0px rgba(0, 0, 0, 0.16)`
  },
  ({ showSuggestions }) => ({
    display: showSuggestions ? 'block' : 'none'
  })
)
